// Adapted from the supplied autumn-product.liquid background only.
// Mobile breakpoint follows the approved theme range (<810px).
if (!customElements.get('sembonia-maple-background')) {
customElements.define('sembonia-maple-background', class extends HTMLElement {
    async connectedCallback() {
        const token = {}
        this.token = token
        let THREE
        try { THREE = await import('https://esm.sh/three@0.185.1') }
        catch (error) { console.warn('Autumn background failed to load.', error); return }
        if (!this.isConnected || this.token !== token) return
        const container = this
        const leaves = Number(this.dataset.leaves || 14)
        const speed = Number(this.dataset.speed || 25) / 100
        const wind = Number(this.dataset.wind ?? 35) / 100
        const size = Number(this.dataset.size || 65) / 1000
        const opacity = Number(this.dataset.opacity || 22) / 100
        try {
        const scene = new THREE.Scene()

        const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10)

        camera.position.z = 5

        const renderer = new THREE.WebGLRenderer({
            alpha: true,
            antialias: false,
            powerPreference: "low-power",
        })

        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5))

        renderer.setClearColor(0x000000, 0)

        renderer.domElement.style.position = "absolute"
        renderer.domElement.style.left = "0"
        renderer.domElement.style.top = "0"
        renderer.domElement.style.width = "100%"
        renderer.domElement.style.height = "100%"
        renderer.domElement.style.pointerEvents = "none"

        container.appendChild(renderer.domElement)

        // =====================================================
        // CREATE NATURAL MAPLE LEAF TEXTURE
        // =====================================================

        const canvas = document.createElement("canvas")

        canvas.width = 256
        canvas.height = 256

        const ctx = canvas.getContext("2d")

        if (!ctx) { renderer.dispose(); renderer.domElement.remove(); return; }

        ctx.clearRect(0, 0, 256, 256)

        // -----------------------------------------------------
        // LEAF GRADIENT
        // -----------------------------------------------------

        const gradient = ctx.createRadialGradient(128, 115, 15, 128, 125, 145)

        gradient.addColorStop(0, "#D98532")

        gradient.addColorStop(0.42, "#C76B27")

        gradient.addColorStop(0.75, "#AD4F20")

        gradient.addColorStop(1, "#843719")

        ctx.fillStyle = gradient

        // -----------------------------------------------------
        // NATURAL MAPLE SILHOUETTE
        // -----------------------------------------------------

        ctx.beginPath()

        ctx.moveTo(128, 12)

        // TOP LOBE
        ctx.lineTo(118, 48)
        ctx.lineTo(101, 31)
        ctx.lineTo(105, 67)

        // UPPER LEFT
        ctx.lineTo(78, 48)
        ctx.lineTo(84, 79)

        // LEFT UPPER POINT
        ctx.lineTo(45, 65)
        ctx.lineTo(60, 94)

        // LEFT OUTER POINT
        ctx.lineTo(18, 101)
        ctx.lineTo(57, 116)

        // LOWER LEFT POINT
        ctx.lineTo(34, 139)
        ctx.lineTo(69, 133)

        // LOWER LEFT LOBE
        ctx.lineTo(58, 165)
        ctx.lineTo(89, 147)

        // LOWER CENTER
        ctx.lineTo(96, 190)
        ctx.lineTo(116, 159)

        // BOTTOM
        ctx.lineTo(128, 218)

        // LOWER RIGHT
        ctx.lineTo(140, 159)
        ctx.lineTo(160, 190)
        ctx.lineTo(167, 147)

        // LOWER RIGHT LOBE
        ctx.lineTo(198, 165)
        ctx.lineTo(187, 133)

        // RIGHT POINT
        ctx.lineTo(222, 139)
        ctx.lineTo(199, 116)

        // OUTER RIGHT
        ctx.lineTo(238, 101)
        ctx.lineTo(200, 94)

        // UPPER RIGHT
        ctx.lineTo(211, 65)
        ctx.lineTo(178, 79)

        // UPPER RIGHT LOBE
        ctx.lineTo(178, 48)
        ctx.lineTo(151, 67)

        // TOP RIGHT
        ctx.lineTo(155, 31)
        ctx.lineTo(138, 48)

        ctx.closePath()

        ctx.fill()

        // =====================================================
        // NATURAL EDGE DETAILS
        // =====================================================

        ctx.save()

        ctx.clip()

        // -----------------------------------------------------
        // SUBTLE COLOR VARIATION
        // -----------------------------------------------------

        const softGradient = ctx.createRadialGradient(88, 80, 5, 128, 128, 160)

        softGradient.addColorStop(0, "rgba(244,166,66,0.20)")

        softGradient.addColorStop(0.5, "rgba(255,150,40,0.04)")

        softGradient.addColorStop(1, "rgba(75,25,10,0.18)")

        ctx.fillStyle = softGradient

        ctx.fillRect(0, 0, 256, 256)

        // -----------------------------------------------------
        // CENTRAL VEIN
        // -----------------------------------------------------

        ctx.strokeStyle = "rgba(93,43,19,0.62)"

        ctx.lineWidth = 3

        ctx.lineCap = "round"

        ctx.beginPath()

        ctx.moveTo(128, 215)
        ctx.quadraticCurveTo(126, 165, 128, 42)

        ctx.stroke()

        // -----------------------------------------------------
        // MAIN VEINS
        // -----------------------------------------------------

        ctx.strokeStyle = "rgba(91,43,18,0.48)"

        ctx.lineWidth = 2

        // LEFT VEINS

        ctx.beginPath()

        ctx.moveTo(128, 155)
        ctx.quadraticCurveTo(103, 128, 55, 100)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(128, 133)
        ctx.quadraticCurveTo(103, 108, 82, 76)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(128, 105)
        ctx.quadraticCurveTo(113, 76, 103, 48)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(118, 172)
        ctx.quadraticCurveTo(91, 151, 67, 140)

        ctx.stroke()

        // RIGHT VEINS

        ctx.beginPath()

        ctx.moveTo(128, 155)
        ctx.quadraticCurveTo(153, 128, 201, 100)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(128, 133)
        ctx.quadraticCurveTo(153, 108, 174, 76)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(128, 105)
        ctx.quadraticCurveTo(143, 76, 153, 48)

        ctx.stroke()

        ctx.beginPath()

        ctx.moveTo(138, 172)
        ctx.quadraticCurveTo(165, 151, 189, 140)

        ctx.stroke()

        // -----------------------------------------------------
        // SECONDARY VEINS
        // -----------------------------------------------------

        ctx.strokeStyle = "rgba(105,47,17,0.27)"

        ctx.lineWidth = 1

        const secondaryVeins = [
            [92, 121, 65, 111],
            [83, 103, 59, 91],
            [103, 91, 88, 67],
            [101, 143, 76, 130],

            [164, 121, 191, 111],
            [173, 103, 197, 91],
            [153, 91, 168, 67],
            [155, 143, 180, 130],
        ]

        for (const vein of secondaryVeins) {
            ctx.beginPath()

            ctx.moveTo(vein[0], vein[1])

            ctx.lineTo(vein[2], vein[3])

            ctx.stroke()
        }

        // -----------------------------------------------------
        // SUBTLE ORGANIC SPECKLING
        // -----------------------------------------------------

        for (let i = 0; i < 90; i++) {
            const x = 35 + Math.random() * 185

            const y = 40 + Math.random() * 140

            const radius = 0.3 + Math.random() * 1.1

            ctx.fillStyle =
                Math.random() > 0.45
                    ? "rgba(72,30,14,0.16)"
                    : "rgba(255,190,90,0.08)"

            ctx.beginPath()

            ctx.arc(x, y, radius, 0, Math.PI * 2)

            ctx.fill()
        }

        ctx.restore()

        // =====================================================
        // STEM
        // =====================================================

        ctx.strokeStyle = "rgba(68,30,14,0.8)"

        ctx.lineWidth = 4

        ctx.lineCap = "round"

        ctx.beginPath()

        ctx.moveTo(128, 212)

        ctx.quadraticCurveTo(121, 230, 108, 242)

        ctx.stroke()

        // =====================================================
        // THREE TEXTURE
        // =====================================================

        const texture = new THREE.CanvasTexture(canvas)

        texture.colorSpace = THREE.SRGBColorSpace

        texture.minFilter = THREE.LinearFilter

        texture.magFilter = THREE.LinearFilter

        texture.generateMipmaps = false

        // =====================================================
        // LEAF GEOMETRY
        // =====================================================

        const geometry = new THREE.PlaneGeometry(1, 1)

        // =====================================================
        // MATERIAL
        // =====================================================

        const material = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
            opacity,
            side: THREE.DoubleSide,
            depthWrite: false,
            alphaTest: 0.02,
        })

        // =====================================================
        // LEAF COUNT
        // =====================================================

        const isMobile = window.innerWidth < 810

        const count = Math.max(6, Math.round(isMobile ? leaves * 0.55 : leaves))

        const mesh = new THREE.InstancedMesh(geometry, material, count)

        mesh.frustumCulled = false
        scene.add(mesh)
        let aspect = 1

        // =====================================================
        // AUTUMN COLOR VARIATION
        // =====================================================

        const autumnColors = [
            "#D47A2C",
            "#C45D22",
            "#B84D1E",
            "#D98232",
            "#A8461C",
            "#C96A25",
        ]

        // =====================================================
        // LEAF DATA
        // =====================================================

        const leafData = []

        for (let i = 0; i < count; i++) {
            mesh.setColorAt(
                i,
                new THREE.Color(
                    autumnColors[
                        Math.floor(Math.random() * autumnColors.length)
                    ]
                )
            )

            leafData.push({
                x: Math.random() * 2.35 - 1.175,

                y: Math.random() * 2.45 - 1.15,

                z: Math.random() * 1.5 - 0.75,

                scale: 0.65 + Math.random() * 0.65,

                rotationZ: Math.random() * Math.PI * 2,

                rotationSpeed: (Math.random() - 0.5) * 0.006,

                phase: Math.random() * Math.PI * 2,

                fall: (0.55 + Math.random() * 0.55) * speed,

                wind: 0.55 + Math.random() * 0.7,

                flutter: 0.25 + Math.random() * 0.3,
            })
        }

        if (mesh.instanceColor) {
            mesh.instanceColor.needsUpdate = true
        }

        // =====================================================
        // RESIZE
        // =====================================================

        const resize = () => {
            const width = container.clientWidth

            const height = container.clientHeight

            if (!width || !height) return

            renderer.setSize(width, height, false)

            const previousAspect = aspect
            aspect = width / height
            leafData.forEach(leaf => { leaf.x *= aspect / previousAspect })

            camera.left = -aspect
            camera.right = aspect
            camera.top = 1
            camera.bottom = -1

            camera.updateProjectionMatrix()
        }

        resize()

        const resizeObserver = new ResizeObserver(resize)

        resizeObserver.observe(container)

        // =====================================================
        // ANIMATION
        // =====================================================

        const dummy = new THREE.Object3D()

        let frame = 0
        let previousTime = 0
        let elapsed = 0
        let visible = true

        const animate = (time) => {
            frame = 0
            if (visible && !document.hidden) frame = requestAnimationFrame(animate)

            const delta = previousTime ? Math.min((time - previousTime) / 1000, 0.05) : 0
            previousTime = time
            elapsed += delta
            const t = elapsed

            for (let i = 0; i < count; i++) {
                const leaf = leafData[i]

                // -------------------------------------------------
                // FALLING
                // -------------------------------------------------

                leaf.y -= leaf.fall * 0.33 * delta

                // -------------------------------------------------
                // GENTLE WIND
                // -------------------------------------------------

                const windX =
                    Math.sin(t * 0.23 + leaf.phase) * 0.095 * wind * leaf.wind

                const windX2 =
                    Math.sin(t * 0.11 + leaf.phase * 1.8) * 0.035 * wind

                // -------------------------------------------------
                // RESET
                // -------------------------------------------------

                if (leaf.y < -1.3) {
                    leaf.y = 1.12 + Math.random() * 0.35

                    leaf.x = (Math.random() * 2.4 - 1.2) * aspect

                    leaf.z = Math.random() * 1.5 - 0.75
                }

                // -------------------------------------------------
                // NATURAL ROTATION
                // -------------------------------------------------

                leaf.rotationZ += leaf.rotationSpeed * 60 * delta

                // -------------------------------------------------
                // 3D FLUTTER
                // -------------------------------------------------

                const rotationX = Math.sin(t * leaf.flutter + leaf.phase) * 0.55

                const rotationY =
                    Math.cos(t * leaf.flutter * 0.72 + leaf.phase) * 0.48

                // -------------------------------------------------
                // POSITION
                // -------------------------------------------------

                dummy.position.set(
                    leaf.x + windX + windX2,

                    leaf.y,

                    leaf.z
                )

                // -------------------------------------------------
                // ROTATION
                // -------------------------------------------------

                dummy.rotation.set(rotationX, rotationY, leaf.rotationZ)

                // -------------------------------------------------
                // SCALE
                // -------------------------------------------------

                const s = size * leaf.scale

                dummy.scale.set(s, s, s)

                dummy.updateMatrix()

                mesh.setMatrixAt(i, dummy.matrix)
            }

            mesh.instanceMatrix.needsUpdate = true

            renderer.render(scene, camera)
        }

        const refresh = () => {
            cancelAnimationFrame(frame)
            previousTime = 0
            animate(performance.now())
        }
        const observer = new IntersectionObserver(entries => {
            visible = entries[0].isIntersecting
            refresh()
        })
        observer.observe(container)
        document.addEventListener('visibilitychange', refresh)
        refresh()
        this.cleanup = () => {
            cancelAnimationFrame(frame)

            resizeObserver.disconnect()

            observer.disconnect()
            document.removeEventListener('visibilitychange', refresh)
            mesh.dispose()
            geometry.dispose()
            material.dispose()
            texture.dispose()

            renderer.dispose()

            if (renderer.domElement.parentNode === container) {
                container.removeChild(renderer.domElement)
            }
        }
        } catch (error) {
            if (this.cleanup) this.cleanup()
            this.replaceChildren()
            console.warn('Autumn background unavailable.', error)
        }
    }
    disconnectedCallback() {
        this.token = null
        if (this.cleanup) this.cleanup()
        this.cleanup = null
    }
})
}
